import { Row, Skeleton } from '@fs/zion-ui'
import React from 'react'

type Props = {
  buttonSize: 'lg' | 'md' | 'xs' | 'sm' | 'xl'
}

export default function IndicatorsRowSkeleton({ buttonSize }: Props): JSX.Element {
  return (
    <Row gutters="xxs">
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <Skeleton.IconButton size={buttonSize} />
    </Row>
  )
}
